<template>
  <div>
    <div>
      <Navigation />
    </div>
    <Mypostheader @sort="handleSort" />
    <div v-if="loading" class="loader-container">
      <PulseLoader size="20px" color="#3467D5" />
    </div>
    <div v-else class="cards-section">
      <div class="cards-section">
    <div class="cards-collection">
      <div
        v-for="(service, index) in services"
        :key="index"
        @click="navigateToUser(service.servicesID, service.userID,service.servicesName)"
        class="cards"
      >
        <div class="card-headers">
          <!-- <div class="profile-img">
            <img :src="profileDb" />
          </div> -->

          <div class="header-content">
            <div class="user-name">
                <p class="card-heading">{{ truncate(service.servicesName, 25) }}</p>
              
            </div>
          </div>

          <div class="actions">
            <img src="../icons/Actions.svg" alt="actions" @click.stop="openShare(service)" />
          </div>
            <div v-if="showShare" class="share-overlay" @click.self="showShare = false">
              <div class="share-box">
                <button class="close-btn" @click="showShare = false">×</button>
                <h3>Share this Post</h3>
                <div class="share-options">
                  <div class="share-item" @click.stop="shareWhatsApp(selectedService)">
                    <i class="fab fa-whatsapp"></i>
                    <span>WhatsApp</span>
                  </div>
                  <div class="share-item" @click.stop="shareTwitter(selectedService)">
                    <i class="fab fa-twitter"></i>
                    <span>Twitter (X)</span>
                  </div>
                  <div class="share-item" @click.stop="shareFacebook(selectedService)">
                    <i class="fab fa-facebook-f"></i>
                    <span>Facebook</span>
                  </div>
                  <div class="share-item" @click.stop="shareEmail(selectedService)">
                    <i class="fas fa-envelope"></i>
                    <span>Email</span>
                  </div>
                  <div class="share-item" @click.stop="shareInstagram(selectedService)">
                    <i class="fab fa-instagram"></i>
                    <span>Instagram</span>
                  </div>
                  <div class="share-item" @click.stop="copyLink(selectedService)">
                    <i class="fas fa-link"></i>
                    <span>Copy Link</span>
                  </div>
                </div>
              </div>
            </div>
       
        
          
        </div>

        <div class="card-img">
          <img
            :src="service.imageUrl || defaultImage"
            alt="room images"
          />
        </div>

        <div class="card-details">
          <div class="profile-img">
            <img :src="ProfilePic" alt="User profile" />
          </div>
          <div class="card-title">
            <div class="user-row">
              <p class="card-heading">{{ service.userDetails?.userName || "Unknown user" }}</p>
             <span
  v-if="service.userDetails && (service.userDetails.emailVerified === true || service.userDetails.phoneVerified === true)"
  class="verify-tick"
  title="Verified Account"
  style="margin-left:2px; display:inline-flex; align-items:center; vertical-align:middle;"
>
 <!-- <svg width="1em" height="1em" viewBox="0 0 24 24" style="display:block;" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="#2196F3"/>
    <path d="M9.5 12.5l2 2 4-4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="12" cy="12" r="9.2" stroke="#1976D2" stroke-width="1.6" fill="none"/>
  </svg> -->
 <svg width="26" height="26" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:block;">
                   <rect x="8" y="20" width="48" height="28" rx="4" fill="#E74C3C"/>
                   <polygon points="32,38 8,20 56,20" fill="#C0392B"/>
                   <polygon points="32,38 8,48 8,20" fill="#000" opacity="0.07"/>
                   <polygon points="32,38 56,48 56,20" fill="#000" opacity="0.07"/>
                   <circle cx="32" cy="20" r="12" fill="#ECECEC"/>
                   <circle cx="32" cy="20" r="8" fill="#26A69A"/>
                   <path d="M29 20l3 3 5-5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                 </svg>
</span>
            </div>
            <!-- <p class="card-desc">{{ truncate(service.Description, 60) }}</p> -->
          </div>

          <!-- <div class="card-servicetype">
            <p>{{ service.serviceType1 || "N/A" }}</p>
          </div> -->
                 <div class="card-servicetype">
  <p
    class="no-pointer"
    :title="'service type'"
  >
    {{ service.serviceType1 || "Service" }}
  </p>
</div>
        </div>
         <div class="add-details">
            <p class="card-desc">
              {{
                service.Description
                  ? truncate(service.Description, 40)
                  : "No description available"
              }}
            </p>
        </div>

        <div class="card-detail" v-if="isvalid">
          <div class="info-row">
            <div class="info-item">
              <img src="../icons/locIcon.svg" alt="location" />
              <p>{{ service.location || "No location" }}</p>
            </div>
          </div>

          <div class="info-row">
            <div class="info-item">
              <img src="../icons/callIcon.svg" alt="phone" />
              <p>{{ service.Phone ||"+1 347-309-5344" }}</p>
            </div>
          </div>
        </div>

        <!-- Enable/Disable Button Only -->
        <div class="card-btn">
          <button
            v-if="service.isActive === 'false'"
            class="outline"
            @click.stop="enableAd(service.servicesID,service.userID)"
          >
            Enable Ad
          </button>
          <button
            v-else
            class="outline"
            @click.stop="disableAd(service.servicesID,service.userID)"
          >
            Disable Ad
          </button>
        </div>
      </div>
    </div>
    <FloatingView
      v-if="showFloating && selectedService"
      :service="selectedService"
      @close="closeFloating"
    />
  </div>
    </div>
    <div>
      <!-- <div v-if="showLogin">
        <div>
      <AuthModal
  v-if="showLogin"
  :mode="authMode"
  @switchMode="switchMode"
  @close="closeLogin"
/>
      <PostModal
  v-if="showPostModal"
  :type="postMode"
  :postId="postId"
  @close="showPostModal = false"
/>


        </div>
      </div> -->
     <!-- Auth Modal -->
<AuthModal
  v-if="showLogin"
  :mode="authMode"
  @switchMode="switchMode"
  @close="closeLogin"
/>

<!-- Post Modal -->
<PostModal
  v-if="showPostModal"
  :type="postMode"
  :postId="postId"
  @close="showPostModal = false"
/>
 
<div class="pagination-wrapper">
 <button
      class="nav-btn"
      :disabled="currentPage === 1"
      @click="changePage(currentPage - 1)"
      aria-label="Previous page"
    >
      <img
        src="../icons/leftIcon.svg"
        alt=""
        class="nav-icon"
        aria-hidden="true"
      />
      <span class="nav-text">Previous</span>
    </button>

  <div class="pagination-pages">
    <span 
      v-for="page in visiblePages"
      :key="page"
      @click="page !== '...' && changePage(page)"
      :class="['page-number', { active: page === currentPage, dots: page === '...' }]"
    >
      {{ page }}
    </span>
  </div>

   <button
      class="nav-btn"
      :disabled="currentPage === totalPages"
      @click="changePage(currentPage + 1)"
      aria-label="Next page"
    >
      <span class="nav-text">Next</span>
      <img
        src="../icons/rightIcon.svg"
        alt=""
        class="nav-icon"
        aria-hidden="true"
      />
    </button>
</div>

      <Footer />
    </div>
  </div>
</template>

<script>
import "../../../public/css/main.css";
import { WEB_ORIGIN } from "@/config/apiBase";
import Mypostheader from "./Mypostheader.vue";
import Navigation from "./Navigation.vue";
import Footer from "./footer.vue";
import { fetchServices, loadServiceImages } from "@/services/serviceLoader.js";
import defaultImage from "../icons/cardFrame.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import AuthModal from "./Models/AuthModal.vue";
import PostModal from "./Models/PostModal.vue";
import defaultDP from "../icons/Avatar.svg";
import userDetailsServices from "../../services/userDetailsService";
import axios from "axios";
import { canonicalSlug } from "@/utils/slug";
export default {
  data() {
    return {
      services: [],
      defaultImage: defaultImage,
      loading: true,
      authMode: "login",
         showPostModal: false,
    postMode: "new", // new | edit
    postId: null,
      showLogin: false,
      showFloating: false,
      isvalid: false,
      profileDb:defaultDP,
      ProfilePic:null,
      authServiceId:null,
         showShare: false,
          selectedService: null,
    currentPage: 1,
    totalPages: 1,
    limit: 10,
  copiedLink: '',
      sortType: 'date',
    };
  },
  components: {
    Mypostheader,
    Navigation,
    Footer,
    PulseLoader,
    AuthModal,
    PostModal
  },
  computed: {
  visiblePages() {
    const pages = [];
    const total = this.totalPages;
    const current = this.currentPage;

    if (total <= 7) {
      for (let i = 1; i <= total; i++) pages.push(i);
    } else {
      pages.push(1);
      if (current > 3) pages.push("...");
      const start = Math.max(2, current - 1);
      const end = Math.min(total - 1, current + 1);

      for (let i = start; i <= end; i++) pages.push(i);
      if (current < total - 2) pages.push("...");
      pages.push(total);
    }

    return pages;
  }
},

  async mounted() {
    try {
      this.verifyToken();
      const userId = localStorage.getItem("userid");
      this.sortType = 'date'; // Always set to date on load
      await this.loadServices(userId, this.currentPage);

      userDetailsServices.getProfileImage(userId).then((imgUrl) => {
        this.ProfilePic = imgUrl || defaultDP;
      });

      // Fetch verification status for each service's user
      await Promise.all(
        this.services.map(async (srv, idx) => {
          const userId = srv.userID;
          if (!srv.userDetails) srv.userDetails = {};
          try {
            const verRes = await userDetailsServices.getVerificationStatus(userId);
            this.services[idx].userDetails.emailVerified = verRes?.data?.item?.emailVerified === true;
            this.services[idx].userDetails.phoneVerified = verRes?.data?.item?.phoneVerified === true;
          } catch (e) {
            this.services[idx].userDetails.emailVerified = false;
            this.services[idx].userDetails.phoneVerified = false;
          }
        })
      );
    } finally {
      this.loading = false;
    }
  },

methods: {
  enableAd(servicesID,userID) {
    console.log("Enabling ad for service ID:", servicesID); 
 
    
  axios.put("/api/services", {
    servicesID: servicesID,
    userID: userID,
    isActive: "true",
  }).then(() => {
  
    window.location.reload();
      toast.success("Ad Enabled");
  });
  },
  disableAd(servicesID,userID ) {
     console.log("Disabling ad for service ID:", servicesID); 
    console.log("User ID:", userID);
   axios.put("/api/services", {
    servicesID: servicesID,
    userID: userID,
    isActive: "false",
  }).then(() => {
   
    window.location.reload();
     toast.success("Ad Disabled");
  });
  },
  async loadServices(userId, page = 1) {
    this.loading = true;

    const res = await fetchServices(userId, page, this.limit);
    let loadedServices = await loadServiceImages(res.services, this.defaultImage);
    this.services = this.sortServices(loadedServices, this.sortType);
    this.currentPage = res.currentPage;
    this.totalPages = res.totalPages;

    console.log("📦 Received services:", this.services);

    this.loading = false;
  },
  async handleSort(type) {
    this.sortType = type;
    // Reload services from backend and apply sorting
    const userId = localStorage.getItem("userid");
    await this.loadServices(userId, this.currentPage);
  },

  sortServices(services, type) {
    if (!Array.isArray(services)) return [];
    if (type === 'date') {
      // Descending by updatedTime (ISO string)
      return [...services].sort((a, b) => {
        const dateA = new Date(a.updatedTime || 0);
        const dateB = new Date(b.updatedTime || 0);
        return dateB - dateA;
      });
    } else if (type === 'name') {
      // Ascending by servicesName (A-Z)
      return [...services].sort((a, b) => {
        const nameA = (a.servicesName || '').toLowerCase();
        const nameB = (b.servicesName || '').toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    }
    return services;
  },

  async changePage(page) {
    const userId = localStorage.getItem("userid");
    this.sortType = 'date'; // Always set to date on page change
    await this.loadServices(userId, page);
  },

  verifyToken() {
    const token = localStorage.getItem("auth-token");
    // Guest (no token): asking the server would 401 with "Invalid or expired
    // token", which the global interceptor treats as an expired session and
    // shows the "session expired" banner to a user who never signed in.
    if (!token) {
      this.isvalid = false;
      return;
    }
    axios
      .post(
        "/api/verify-token",
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }
      )
      .then(() => (this.isvalid = true))
      .catch(() => (this.isvalid = false));
  },

 editpost(servicesID) {
  this.requireLogin(() => {
    this.closeAllPopups();

    this.postMode = "edit";
    this.postId = servicesID;
    this.showPostModal = true;
  });
},


  switchMode(mode) {
    this.authMode = mode;
  },

  requireLogin(callback) {
    if (this.isvalid) return callback();
    localStorage.setItem("redirectTo", this.$route.fullPath);

    this.closeAllPopups();
    this.authMode = "login";
    this.showLogin = true;
  },

  closeLogin() {
    this.showLogin = false;
  },

  closeAllPopups() {
    this.showFloating = false;
    this.showUserModal = false;
    this.showLogin = false;
      this.showPostModal = false;
  },

  truncate(text, length) {
    if (!text) return "";
    return text.length > length ? text.substring(0, length) + "..." : text;
  },

  // navigateToUser(servicesID, userID, servicesName) {
  //   this.requireLogin(() => {
  
  //       console.log("services id", servicesID);
  //      console.log("services id", userID);
  //         console.log("services id", servicesName);
    
  // localStorage.setItem(
  //   "viewPostContext",
  //   JSON.stringify({
  //     servicesID,
  //     userID,
  //     from: "myads",
  //   })
  // );

  // // Safely handle null/undefined service name
  // const safeServiceName = servicesName ? servicesName.toLowerCase().trim().replace(/\s+/g, "-") : "service";
  // this.$router.push({
  //   name: "view-post",
  //   params: {
  //     serviceName: safeServiceName,
  //   },
  // });
  //   });
  // },
    async navigateToUser(servicesID, userID, servicesName) {
      localStorage.setItem(
        "viewPostContext",
        JSON.stringify({
          servicesID,
          userID,
          from: "myads",
        })
      );

      // The stored slug is the only one guaranteed to resolve, so it's used
      // verbatim — a "+N" duplicate-title suffix must survive untouched.
      let url = null;
      try {
        const res = await axios.post("/api/serviceslinklist", {
          serviceID: servicesID,
        });
        if (res.data && res.data.items && res.data.items[0] && res.data.items[0].url) {
          url = res.data.items[0].url;
        }
      } catch (err) {
       console.warn("Error fetching service link:", err);
      }
      // Always navigate; derive the slug from the title only if the lookup
      // failed, using the same rule that created it (see utils/slug.js).
      this.$router.push({
        name: "view-post",
        params: {
          serviceName: url || canonicalSlug(servicesName),
        },
      });
    }, 
      async getServiceUrl(service) {
              if (!service) return window.location.href;
              let url = WEB_ORIGIN + "/view-post/";
              try {
                const res = await axios.post("/api/serviceslinklist", { serviceID: service.servicesID });
                if (res.data && res.data.items && res.data.items[0] && res.data.items[0].url) {
                  url += res.data.items[0].url;
                } else {
                  url += canonicalSlug(service.servicesName);
                }
              } catch (e) {
                url += canonicalSlug(service.servicesName);
              }
              return url;
            },
            async shareWhatsApp(service) {
              const url = await this.getServiceUrl(service);
              window.open(`https://wa.me/?text=${encodeURIComponent(url)}`, "_blank");
            },
            async shareTwitter(service) {
              const url = await this.getServiceUrl(service);
              window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`, "_blank");
            },
            async shareFacebook(service) {
              const url = await this.getServiceUrl(service);
              window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, "_blank");
            },
            async shareEmail(service) {
              const url = await this.getServiceUrl(service);
              window.location.href = `mailto:?subject=Check this out&body=${encodeURIComponent(url)}`;
            },
            shareInstagram() {
              // Open the specified Instagram page directly
              window.open("https://www.instagram.com/renants_classifieds/", "_blank");
            },
            openShare(service) {
              this.selectedService = service;
              this.showShare = true;
            },
            async copyLink(service) {
              const url = await this.getServiceUrl(service);
              try {
                await navigator.clipboard.writeText(url);
                this.copiedLink = url;
                this.$toast && this.$toast.success ? this.$toast.success("Link copied to clipboard!") : alert("Link copied to clipboard!");
              } catch (e) {
                this.$toast && this.$toast.error ? this.$toast.error("Failed to copy link") : alert("Failed to copy link");
              }
            },

}

};
</script>

<style scoped>
.nav-btn {
  background: none;
  border: none;
  color: #444;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
}

.nav-btn:disabled {
  color: #666;
  cursor: not-allowed;
  opacity: 0.7;
}
.pages {
  display: flex;
  gap: 10px;
  align-items: center;
}

.page-btn {
  background: none;
  border: none;
  color: #555;
  font-weight: 500;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  cursor: pointer;
}

.page-btn.active {
  background-color: #ede3ff;
  color: #7F56D9;
  font-weight: 600;
}
.nav-btn img{
  width: 15px;
  height: 15px;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  padding: 24px 32px
}

.pagination-arrow {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #333;
  font-family: "Inter", sans-serif;
}

.pagination-arrow:disabled {
  color: #999;
  cursor: not-allowed;
}

.pagination-pages {
  display: flex;
  gap: 12px;
  align-items: center;
}

.page-number {
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  color: #4b5563;
}

.page-number.active {
  background: #f3f0ff;
  font-weight: 600;
  color: #6c47ff;
}

.page-number.dots {
  cursor: default;
  color: #9ca3af;
}

.cards-section {
  width: 100%;
  max-width: 1280px;
  margin: 24px auto;
  /* padding: 0 32px;            */
  box-sizing: border-box;
}

.cards-collection {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 0 24px;
  justify-content: flex-start;
}
.add-details{
   padding-left:16px;
    padding-bottom: 10px;
}
.cards {
  flex: 1 1 calc(33.333% - 24px);
  max-width: 390px;
  border: 1px solid #e9eaeb;
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
}

.card-headers {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  box-sizing: border-box;
  gap: 5px;
}

.profile-img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  padding: 2px; /* border thickness */
  background: linear-gradient(135deg, #0141ca, #e6ecfa, #017dca);

  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-img img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
}

.card-detail {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 0px 16px 24px 16px;
  box-sizing: border-box;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.loader-container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 60px 0;
}

.info-item img {
  width: 24px;
  height: 24px;
}

.info-item p {
  margin: 0;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #181d27;
  font-weight: 600;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.user-name {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 16px;
}

.user-name p {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #000;
  margin: 0;
}

.badge {
  width: 14px;
  height: 14px;
}

.time {
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  color: #000;
  font-weight: 400;
  line-height: 18px;
}

.actions img {
  width: 30px;
  height: 30px;
  cursor: pointer;
  padding: 4px;
}

.card-img {
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}

.card-img img {
  width: 100%;
  height: 184px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
}

.card-details {
  display: flex;
  justify-content: space-between;
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  align-items: flex-start;
  gap: 8px;
}

.card-title {
  flex: 1;
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
}

.card-heading {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 30px;
  color: #181d27;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-desc {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #535862;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-servicetype {
  flex-shrink: 0;
  border-radius: 2px;
  border: 0.77px solid transparent;
  background: linear-gradient(white, white) padding-box,
    linear-gradient(90deg, #e33629, #017dca) border-box;
  /* margin-right: 16px; */
  height: 28.3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 120px;
}
.no-pointer {
  cursor: default; 
}
.card-servicetype p {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  padding: 3.5px 10.77px;
  margin: 0;
  border-radius: 4px;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(90deg, #e33629, #017dca);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}



@media (max-width: 1280px) {
  .cards {
    flex: 1 1 calc(45% - 24px);
    max-width: 340px;
  }
    .cards-collection {

  justify-content: center;
}

    .card-detail {
    display: flex;
    flex-direction: column;
    padding: 0px 16px 10px 16px;
    width:100%;
  

  }
}

@media (max-width: 768px) {
  .cards {
    flex: 1 1 100%;
    max-width: 100%;
  }

    .card-detail {
    display: flex;
    flex-direction: column;
    width:100%;
      padding: 0px 16px 10px 16px;
  

  }
  .cards-collection {

  justify-content: center;
}
 
}
@media (max-width: 480px) {
  .card-servicetype{
    margin-right: 0px;
  }
      .pagination-wrapper {
        justify-content: center;
        flex-wrap: nowrap;
        gap: 8px;
        padding: 6px 12px;
    }
      .nav-text {
    display: none;
  }

}
/* Username and verify tick alignment */
.user-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
/* .verify-tick {
  width: 1em;
  height: 1em;
  margin-left: 4px;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
} */
</style>
